import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Switch } from '../ui/switch';

interface TimeSelectorRowProps {
  label: string;
  enable: boolean;
  start: string;
  end: string;
  onEnableChange: (checked: boolean) => void;
  onStartChange: (time: string) => void;
  onEndChange: (time: string) => void;
}

const TimeSelectorRow: React.FC<TimeSelectorRowProps> = ({
  label,
  enable,
  start,
  end,
  onEnableChange,
  onStartChange,
  onEndChange,
}) => {
  return (
    <div className="flex items-center justify-between space-x-2 py-2">
      <Label htmlFor={label} className="w-1/3 text-right text-[var(--jr-text-soft)]">
        {label}
      </Label>
      <Switch id={label} checked={enable} onCheckedChange={onEnableChange} className="data-[state=checked]:bg-[color:var(--jr-accent-strong)] data-[state=unchecked]:bg-[color:var(--jr-surface-muted)]" />
      <div className="flex space-x-2 w-2/3">
        <Input
          type="time"
          value={start}
          onChange={(e) => onStartChange(e.target.value)}
          className="jr-input w-1/2"
          disabled={!enable}
        />
        <Input
          type="time"
          value={end}
          onChange={(e) => onEndChange(e.target.value)}
          className="jr-input w-1/2"
          disabled={!enable}
        />
      </div>
    </div>
  );
};

export default TimeSelectorRow;
